import React from 'react';
import GeneralAnalyticsComponent from './GeneralAnalyticsComponent';

const GeneralAnalytics = ({ initialSelection, onSelectionApplied }) => (
  <GeneralAnalyticsComponent
    initialSelection={initialSelection}
    onSelectionApplied={onSelectionApplied}
  />
);

export default GeneralAnalytics;
